import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './codeOfConduct.component.html',
	styleUrls: ['./codeOfConduct.component.css']
})

export class CodeOfConductComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
		console.log("coc working");
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/codeOfConduct.component.ts